import { I18nUtil } from "@utils/i18n";
import KeyStatItem from "./KeyStatItem";
import React from "react";
import Translations from "@translate/components/TokenDetails/KeyStats";
import { cn } from "utils";

const I18n = I18nUtil.createScoped(Translations);

export interface KeyStatsProps {
  /** 需要外部做千分位处理 值不存在展示为-- */
  tradingVolume?: string;
  /** 需要外部做千分位处理 值不存在展示为-- */
  circulatingSupply?: string;
  /** 需要外部做千分位处理 值不存在展示为-- */
  marketCap?: string;
  /** 需要外部做千分位处理 值不存在展示为-- */
  totalSupply?: string;
  /** 需要外部做千分位处理 值不存在展示为-- */
  maxSupply?: string;
  /** 需要外部做千分位处理 值不存在展示为-- */
  fdv?: string;
  /** 需要外部做千分位处理 值不存在展示为-- */
  holders?: string;
  /** 需要格式化为设计稿的日期格式 值不存在展示为-- */
  creationDate?: string;
  pollAddress?: string;
  dexId?: string;
  tx24h?: string;
  liquidity?: string;
  marker24h?: string;
  txns24h?: string;
  className?: string;
  copyAddress?: string;
  isPollToken?: boolean;
  fdr?: string;
}
/** 组件内部没有对数据做任何格式化，需要外部处理 */
export const KeyStats: React.FC<KeyStatsProps> = ({
  tradingVolume,
  circulatingSupply,
  marketCap,
  totalSupply,
  maxSupply,
  fdv,
  holders,
  creationDate,
  dexId,
  pollAddress,
  txns24h,
  marker24h,
  liquidity,
  className = "",
  copyAddress,
  isPollToken,
  fdr,
}) => {
  if (isPollToken) {
    // key stat：trading valume 、FDV、market cap、maker（待确认）、Pair created，pool adress，dex
    return (
      <div className={cn("w-full", className)}>
        <h2
          aria-label="Key Stats h2"
          data-openreplay-label="Key Stats h2 Semantic"
          id="sem-key-stats-h2"
          className="headline_regular_s text-content_primary mb-4"
        >
          {I18n.t("Key Stats")}
        </h2>
        <div className="grid grid-cols-2 gap-3">
          <KeyStatItem
            label={I18n.t("Trading Volume (24hr)")}
            value={tradingVolume}
          />
          <KeyStatItem label={I18n.t("Market Cap")} value={marketCap} />
          <KeyStatItem label={I18n.t("Makers (24hr)")} value={marker24h} />
          <KeyStatItem label={I18n.t("Liquidity")} value={liquidity} />
          <KeyStatItem
            label={I18n.t("Address")}
            value={pollAddress}
            isCopy
            copyValue={copyAddress}
          />
          <KeyStatItem label={I18n.t("DEX")} value={dexId} />
          <KeyStatItem label={I18n.t("Txns24h")} value={txns24h} />
          <KeyStatItem
            label={I18n.t("Date of Creation")}
            value={creationDate}
          />
        </div>
      </div>
    );
  }
  return (
    <div className={cn("w-full", className)}>
      <h2
        aria-label="Key Stats h2"
        data-openreplay-label="Key Stats h2 Semantic"
        id="sem-key-stats-h2-2"
        className="headline_regular_s text-content_primary mb-4"
      >
        {I18n.t("Key Stats")}
      </h2>
      <div className="grid grid-cols-2 gap-3">
        <KeyStatItem
          label={I18n.t("Trading Volume (24hr)")}
          value={tradingVolume}
        />
        <KeyStatItem
          label={I18n.t("Circulating Supply")}
          value={circulatingSupply}
        />
        <KeyStatItem label={I18n.t("Market Cap")} value={marketCap} />
        <KeyStatItem label={I18n.t("Total Supply")} value={totalSupply} />
        <KeyStatItem label={I18n.t("Holders")} value={holders} />
        <KeyStatItem label={I18n.t("Max Supply")} value={maxSupply} />
        <KeyStatItem label={I18n.t("FDV")} value={fdv} />
        {fdr && (
          <KeyStatItem label={I18n.t("Funding Rate")} value={`${fdr}%`} />
        )}
        <KeyStatItem label={I18n.t("Date of Creation")} value={creationDate} />
      </div>
    </div>
  );
};
